import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconShare = createIcon({
  displayName: 'IconShare',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M22 11H20V4H13V2H22V11ZM20 20H4V4H9V6H6V18H18V15H20V20ZM16.59 6H18V7.41L10.71 14.71L9.28999 13.29L16.59 6Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
